import { Routes, Route } from 'react-router-dom'
import InterventionStart from './(pages)/start/page'
import MainIntervention from './(pages)/main/page'
import VisitRapport from './(pages)/visit-rapport/page'
import Questionnaire from './(pages)/questionnaire/page'
import Invoicing from './(pages)/invoicing/page'

const Intervention = () => {
  return (
      <Routes>
        <Route path="*" element={<MainIntervention />}/>
        <Route path="/start" element={<InterventionStart />}/>
        <Route path="/bezoekrapport/*">
          <Route path="" element={<VisitRapport />}/>
          <Route path="vragenlijst/*" element={<Questionnaire />}/>
        </Route>
        <Route path="/facturatie" element={<Invoicing />}/>
      </Routes>
  )
}

export default Intervention